import { create } from 'zustand';

interface menuState {
  result: { data: any; listData: any; checked: any };
  bind: (param: { data: any; checked: any; listData: any }) => void;
}
interface menuAdminState {
  result: { data: any; orgData: any; listData: any; viewType: string; selectItem: any };
  bind: (param: { data: any; orgData: any; listData: any }) => void;
  bindData: (param: { data: any }) => void;
  bindDataOption: (param: { data: any; viewType: string; selectItem: any }) => void;
  bindTypeOption: (param: { viewType: string; selectItem: any }) => void;
  bindSelectOption: (param: { selectItem: any }) => void;
}
interface subMenuState {
  result: any;
  bind: (data: any) => void;
}

/**
  MENU 상태
**/
export const menuStore = create<menuState>(set => ({
  result: { data: [], checked: {}, listData: [] },
  bind: (param: { data: any[]; checked: any; listData: [] }) =>
    set((state: any) => ({
      ...state,
      result: {
        ...state.result,
        data: param.data,
        checked: param.checked,
        listData: param.listData,
      },
    })),
}));

/**
  MENU 상태
**/
export const menuAdminStore = create<menuAdminState>(set => ({
  result: { data: [], orgData: [], listData: [], viewType: '', selectItem: {} },
  bind: (param: { data: any[]; orgData: []; listData: [] }) =>
    set((state: any) => ({
      ...state,
      result: {
        ...state.result,
        data: param.data,
        orgData: param.orgData,
        listData: param.listData,
      },
    })),
  bindData: (param: { data: any[] }) =>
    set((state: any) => ({
      ...state,
      result: { ...state.result, data: param.data },
    })),
  bindDataOption: (param: { data: any[]; viewType: string; selectItem: any }) =>
    set((state: any) => ({
      ...state,
      result: {
        ...state.result,
        data: param.data,
        viewType: param.viewType,
        selectItem: param.selectItem,
      },
    })),
  bindTypeOption: (param: { viewType: string; selectItem: any }) =>
    set((state: any) => ({
      ...state,
      result: {
        ...state.result,
        viewType: param.viewType,
        selectItem: param.selectItem,
      },
    })),
  bindSelectOption: (param: { selectItem: any }) =>
    set((state: any) => ({
      ...state,
      result: {
        ...state.result,
        selectItem: param.selectItem,
      },
    })),
}));

/**
  SUB MENU
**/
export const subMenuStore = create<subMenuState>(set => ({
  result: { data: [] },
  bind: (data: any[]) =>
    set((state: any) => ({
      ...state,
      result: { data },
    })),
}));
